import { render } from "./CreateTask.vue?vue&type=template&id=aefe9a94"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"

import "./CreateTask.vue?vue&type=style&index=0&id=aefe9a94&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__